export const TCS_AMOUNT_GO_BUTTON_ACTION = 'TCS_AMOUNT_GO_BUTTON_ACTION'
export const TCS_AMOUNT_GO_BUTTON_SUCCESS = 'TCS_AMOUNT_GO_BUTTON_SUCCESS'

export const TCS_AMOUNT_REPORT_API_ERROR_ACTION = 'TCS_AMOUNT_REPORT_API_ERROR_ACTION'